export type ToastColor = 'success' | 'error' | 'info' | 'warning'

export interface ToastOptions {
  title: string
  color: ToastColor
  duration?: number
  closable?: boolean
  variant?: 'default'
}

export interface ToastContextValue {
  toast: (options: ToastOptions) => void
}

let toastContext: ToastContextValue | null = null

export function setToastContext(value: ToastContextValue | null) {
  toastContext = value
}

export function getToastContext() {
  return toastContext
}
